import { render, staticRenderFns } from "./PageCollection.vue?vue&type=template&id=3e648858&scoped=true&"
import script from "./PageCollection.vue?vue&type=script&lang=js&"
export * from "./PageCollection.vue?vue&type=script&lang=js&"
import style0 from "./PageCollection.vue?vue&type=style&index=0&id=3e648858&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e648858",
  null
  
)

export default component.exports